<template>
  <v-container class="height_100p" style="display: contents">
    <v-row class="height_100p" justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="7" align-self="center">
        <v-card
          class="mb-12 mx-auto card-main-text"
          color="secondary"
          elevation="0"
        >
          <div class="round__logo__main">
            <div class="round__logo__sub">
              <img src="../../../public/logo.png" width="50px" height="50px" />
            </div>
          </div>
          <div class="card-main-text-second"></div>

          <v-sheet
            class="v-sheet--offset rounded-lg v-sheet-with-v-shape mx-auto pa-5"
            elevation="12"
            max-width="calc(100% - 65px)"
          >
            <v-card class="mx-auto rounded-lg" elevation="0">
              <v-card-text>
                <div class="m-auto">
                  <h2 class="text-center text-primary-color font-weight-bold">
                    {{ $t("loginScreen.userLogin") }}
                  </h2>
                  <br />
                  <form class="">
                    <label class="text-midgray-color">{{
                      $t("loginScreen.loginUsingEmailPassword")
                    }}</label>
                    <v-text-field
                      v-model="user_details.email"
                      :label="$t('emailID')"
                      :error-messages="emailErrors"
                      clearable
                      @input="$v.user_details.email.$touch()"
                      @blur="$v.user_details.email.$touch()"
                      :class="{
                        'is-invalid': $v.user_details.email.$error,
                      }"
                      append-icon="mdi-account-outline"
                    ></v-text-field>

                    <v-text-field
                      v-model="user_details.password"
                      :append-icon="
                        isVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                      "
                      @click:append="() => (isVisible = !isVisible)"
                      :type="isVisible ? 'text' : 'password'"
                      :label="$t('password')"
                      :error-messages="passwordErrors"
                      clearable
                      @input="$v.user_details.password.$touch()"
                      @blur="$v.user_details.password.$touch()"
                      :class="{
                        'is-invalid': $v.user_details.password.$error,
                      }"
                      @keydown="enterKeyPressed"
                    ></v-text-field>

                    <v-btn
                      depressed
                      block
                      color="primary"
                      @click="onClickLogin"
                      class="mt-3 text-capitalize"
                      >{{ $t("loginScreen.signin") }}</v-btn
                    >
                  </form>
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-card>
        <loading
          :active="loader"
          :is-full-page="fullPage"
          :opacity="0.9"
          color="#ff6b00"
          :height="height"
          :width="width"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import agentService from "@/services/agentService/AgentService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Login",
  mounted() {
    sessionStorage.clear();
  },
  components: {
    Loading,
  },
  data() {
    return {
      isVisible: false,
      user_details: {
        email: this.$route.params.emailId || "",
        password: "",
      },
      loader: false,
      languageSelected: "en-us",
      dismissCountDown: 20,
      showDismissibleAlert: false,
      language_options: [
        {
          text: "English",
          value: "en-us",
        },
        {
          text: "Chinese",
          value: "zh-cn",
        },
      ],
      fullPage: true,
      height: 100,
      width: 100,
      // alertMsg: {
      //   status: false,
      //   text: "",
      //   timeout: 2000,
      //   color: "blue-grey",
      //   type: "info",
      // },
    };
  },
  validations: {
    user_details: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.user_details.email.$dirty) return errors;
      !this.$v.user_details.email.required && errors.push("E-mail is required");
      !this.$v.user_details.email.email && errors.push("Must be valid e-mail");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.user_details.password.$dirty) return errors;
      !this.$v.user_details.password.required &&
        errors.push("Password is required");
      return errors;
    },
  },
  methods: {
    returnState() {
      return process.env.NODE_ENV === "dev"
        ? "text-white-color primary text-center"
        : "text-primary-color";
    },
    enterKeyPressed(event) {
      if (event.keyCode == 13) this.onClickLogin();
    },
    async onClickLogin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const userDetails = {
        user_name: this.user_details.email,
        password: this.user_details.password,
        user_type: process.env.VUE_APP_USER_TYPE,
      };
      this.$store.commit("username", this.user_details.email);
      sessionStorage.setItem("username", this.user_details.email);
      this.$store.dispatch(
        "Authentication/saveUserEmail",
        this.user_details.email
      );
      try {
        this.loader = true;
        const responseData = await agentService.Login(userDetails);

        setTimeout(() => {
          this.loader = false;
        }, 300);
        if (responseData && responseData.data.success) {
          if (responseData.data.data[0].is_two_factor_auth) {
            setTimeout(
              () => this.$router.push({ name: "Two Factor Auth" }),
              500
            );
          } else {
            if (responseData.data.data[0].user_type) {
              sessionStorage.setItem(
                "user_type",
                responseData.data.data[0].user_type
              );
            }
            const isPermitted = true;
            sessionStorage.setItem("isPermitted", isPermitted);
            sessionStorage.setItem(
              "access_token",
              responseData.data.data[0].access_token
            );
            this.loader = false;
            this.$store.commit(
              "app/set_token",
              responseData.data.data[0]?.access_token
            );
            this.loader = false;
            this.showAlertSuccess(responseData.data.message);
            console.log(
              "responseData.message",
              responseData.data.data[0].is_two_factor_auth
            );
            sessionStorage.setItem(
              "is_evolet_user",
              responseData.data.data[0].is_evolet_user
            );
            sessionStorage.setItem(
              "refresh_token",
              responseData.data.data[0].refresh_token
            );
            sessionStorage.setItem(
              "partner_id",
              responseData.data.data[0].partner_id
            );
            sessionStorage.setItem(
              "partner_country",
              JSON.stringify(responseData.data.data[0].partner_country)
            );
            sessionStorage.setItem(
              "partner_type",
              responseData.data.data[0].partner_type
            );
            sessionStorage.setItem(
              "complete_registration",
              responseData.data.data[0].complete_registration
            );

            this.$store.commit(
              "complete_registration",
              responseData.data.data[0].complete_registration
            );
            setTimeout(() => this.$router.push({ name: "Home" }), 500);
          }
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        console.error("test", error);
        this.showAlertError("Failed: Something went wrong");
        this.loader = false;
      }
    },
    languageChanged() {
      console.log("languageChanged: ", this.languageSelected);
      this.$i18n.locale = this.languageSelected;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.lead {
  font-weight: 400;
  color: $txt;
}
.v-sheet--offset {
  bottom: -20px;
  top: 70px !important;
  position: relative;
}

.language-selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button#input-type__BV_toggle_ {
  font-size: 10px;
}
.forgot-link {
  margin-top: 26px;
  line-height: 3rem;
}

.shadow_class {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  // width: %;
  background: #f8f9fa;
  border-radius: 7px;
}
</style>
